export default __webpack_public_path__ + "static/media/day7.19b03678.png";